import { getConflictingResourceIds, normalizeResourceId } from '../../resources/resources';
import { compareIsoLocalDateTime } from '../../utils/iso';

type EventLike = {
  id: string;
  resourceId: string;
  startAt: string;
  endAt: string;
  status: string;
};

type Params = {
  events: EventLike[];
  resourceId: string;
  startAt: string;
  endAt: string;
  excludeEventId?: string;
};

export function hasResourceTimeConflict({
  events,
  resourceId,
  startAt,
  endAt,
  excludeEventId,
}: Params): boolean {
  const conflictingResourceIds = new Set(
    getConflictingResourceIds(resourceId).map((conflictingResourceId) =>
      normalizeResourceId(conflictingResourceId),
    ),
  );

  return events.some((other) => {
    if (other.status !== 'active') return false;
    if (excludeEventId && other.id === excludeEventId) return false;

    const otherResourceId = normalizeResourceId(other.resourceId);
    if (!conflictingResourceIds.has(otherResourceId)) return false;

    return compareIsoLocalDateTime(startAt, other.endAt) < 0 && compareIsoLocalDateTime(endAt, other.startAt) > 0;
  });
}
